import { AZURE_CLIENT_ID, AZURE_REDIRECT_URI, AZURE_TENANT_ID } from '@/env';
import log from '@/lib/logger';
import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    // only mandatory field that you need to supply
    clientId: AZURE_CLIENT_ID || '',
    // replace the placeholder with your tenant subdomain
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID || ''}`,
    // points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    redirectUri: AZURE_REDIRECT_URI || '',
    // if "true", will navigate back to the original request location before proccessing the auth code response
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // configures cache location. "sessionStorage" is more secure,
    // but "localStorage" gives you SSO between tabs.
    cacheLocation: 'sessionStorage',
    // set this to "true" if you are having issues on IE11 or Edge
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            log.error(message);
            return;
          case LogLevel.Info:
            log.info(message);
            return;
          case LogLevel.Verbose:
            log.debug(message);
            return;
          case LogLevel.Warning:
            log.warn(message);
        }
      },
      piiLoggingEnabled: false,
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
  },
};

export const loginRequest = {
  scopes: [`${AZURE_CLIENT_ID || ''}/read`],
};

// Create an instance of PublicClientApplication
const msalInstance = new PublicClientApplication(msalConfig);

// Handle the redirect flows
msalInstance
  .handleRedirectPromise()
  .then((tokenResponse) => {
    // Handle redirect response
  })
  .catch((error) => {
    // Handle redirect error
  });
